__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/d9338d4/_next/";